export default "__VITE_ASSET__a095bee6__"